import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

function PasswordChangedDialog(props) {
  const { onClose, open } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="password-changed-dialog" open={open}>
      <DialogTitle id="password-changed-dialog">Die Passwortänderung wurde erfolgreich durchgeführt!</DialogTitle>
    </Dialog>
  );
}

PasswordChangedDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default PasswordChangedDialog;
